import { render } from "./grid_col_manage.vue?vue&type=template&id=0190774b"
import script from "./grid_col_manage.vue?vue&type=script&lang=js"
export * from "./grid_col_manage.vue?vue&type=script&lang=js"

import "./grid_col_manage.vue?vue&type=style&index=0&id=0190774b&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__